import { render, staticRenderFns } from "./TabActividadesNeet.vue?vue&type=template&id=7278d970"
import script from "./TabActividadesNeet.vue?vue&type=script&lang=js"
export * from "./TabActividadesNeet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports